import React from 'react';

import { Input, Label, LabelText, Wrapper } from './wrapper';

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  id: string;
  children: React.ReactNode;
};

const InputRadio = ({ children, ...props }: Props) => {
  const { id } = props;
  return (
    <Wrapper>
      <Input
        {...(props as React.DetailedHTMLProps<
          React.InputHTMLAttributes<HTMLInputElement>,
          HTMLInputElement
        >)}
      />
      <Label htmlFor={id}>
        <LabelText>{children}</LabelText>
      </Label>
    </Wrapper>
  );
};

export default InputRadio;
